import { Button as ButtonRaw, ButtonProps } from "@chakra-ui/react";

export const Button = (props: ButtonProps) => {
  return (
    <ButtonRaw
      width={"100%"}
      backgroundColor="brand.200"
      borderRadius={"full"}
      color="brand.900"
      fontWeight={"semibold"}
      {...props}
    />
  );
};
